import { useEffect, useState } from 'react';
import api from './api';

// useRegistrationOpen tells whether this instance accepts new accounts
// (GET /auth/options): null while loading, false when it cannot be read.
export const useRegistrationOpen = () => {
  const [open, setOpen] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get('/auth/options')
      .then((res) => alive && setOpen(Boolean(res.data?.registration)))
      .catch(() => alive && setOpen(false));
    return () => { alive = false; };
  }, []);
  return open;
};
